/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as LoginRouteImport } from './routes/login'
import { Route as CallbackRouteImport } from './routes/callback'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedSetupRouteImport } from './routes/_authenticated/setup'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedPricingRouteImport } from './routes/_authenticated/pricing'
import { Route as AuthenticatedInboxesRouteImport } from './routes/_authenticated/inboxes'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedEventsIndexRouteImport } from './routes/_authenticated/events.index'
import { Route as AuthenticatedRunsRunIdRouteImport } from './routes/_authenticated/runs.$runId'
import { Route as AuthenticatedEventsEventIdRouteImport } from './routes/_authenticated/events.$eventId'

const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const CallbackRoute = CallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedSetupRoute = AuthenticatedSetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPricingRoute = AuthenticatedPricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedInboxesRoute = AuthenticatedInboxesRouteImport.update({
  id: '/inboxes',
  path: '/inboxes',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedEventsIndexRoute =
  AuthenticatedEventsIndexRouteImport.update({
    id: '/events/',
    path: '/events/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedRunsRunIdRoute = AuthenticatedRunsRunIdRouteImport.update({
  id: '/runs/$runId',
  path: '/runs/$runId',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedEventsEventIdRoute =
  AuthenticatedEventsEventIdRouteImport.update({
    id: '/events/$eventId',
    path: '/events/$eventId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/callback': typeof CallbackRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/inboxes': typeof AuthenticatedInboxesRoute
  '/pricing': typeof AuthenticatedPricingRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/setup': typeof AuthenticatedSetupRoute
  '/events/$eventId': typeof AuthenticatedEventsEventIdRoute
  '/runs/$runId': typeof AuthenticatedRunsRunIdRoute
  '/events/': typeof AuthenticatedEventsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/callback': typeof CallbackRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/inboxes': typeof AuthenticatedInboxesRoute
  '/pricing': typeof AuthenticatedPricingRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/setup': typeof AuthenticatedSetupRoute
  '/events/$eventId': typeof AuthenticatedEventsEventIdRoute
  '/runs/$runId': typeof AuthenticatedRunsRunIdRoute
  '/events': typeof AuthenticatedEventsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/callback': typeof CallbackRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/inboxes': typeof AuthenticatedInboxesRoute
  '/_authenticated/pricing': typeof AuthenticatedPricingRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/_authenticated/setup': typeof AuthenticatedSetupRoute
  '/_authenticated/events/$eventId': typeof AuthenticatedEventsEventIdRoute
  '/_authenticated/runs/$runId': typeof AuthenticatedRunsRunIdRoute
  '/_authenticated/events/': typeof AuthenticatedEventsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/callback'
    | '/login'
    | '/onboarding'
    | '/dashboard'
    | '/inboxes'
    | '/pricing'
    | '/settings'
    | '/setup'
    | '/events/$eventId'
    | '/runs/$runId'
    | '/events/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/callback'
    | '/login'
    | '/onboarding'
    | '/dashboard'
    | '/inboxes'
    | '/pricing'
    | '/settings'
    | '/setup'
    | '/events/$eventId'
    | '/runs/$runId'
    | '/events'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/callback'
    | '/login'
    | '/onboarding'
    | '/_authenticated/dashboard'
    | '/_authenticated/inboxes'
    | '/_authenticated/pricing'
    | '/_authenticated/settings'
    | '/_authenticated/setup'
    | '/_authenticated/events/$eventId'
    | '/_authenticated/runs/$runId'
    | '/_authenticated/events/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  CallbackRoute: typeof CallbackRoute
  LoginRoute: typeof LoginRoute
  OnboardingRoute: typeof OnboardingRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/callback': {
      id: '/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof CallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/setup': {
      id: '/_authenticated/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof AuthenticatedSetupRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pricing': {
      id: '/_authenticated/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof AuthenticatedPricingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inboxes': {
      id: '/_authenticated/inboxes'
      path: '/inboxes'
      fullPath: '/inboxes'
      preLoaderRoute: typeof AuthenticatedInboxesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/events/': {
      id: '/_authenticated/events/'
      path: '/events'
      fullPath: '/events/'
      preLoaderRoute: typeof AuthenticatedEventsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/runs/$runId': {
      id: '/_authenticated/runs/$runId'
      path: '/runs/$runId'
      fullPath: '/runs/$runId'
      preLoaderRoute: typeof AuthenticatedRunsRunIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/events/$eventId': {
      id: '/_authenticated/events/$eventId'
      path: '/events/$eventId'
      fullPath: '/events/$eventId'
      preLoaderRoute: typeof AuthenticatedEventsEventIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedInboxesRoute: typeof AuthenticatedInboxesRoute
  AuthenticatedPricingRoute: typeof AuthenticatedPricingRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedSetupRoute: typeof AuthenticatedSetupRoute
  AuthenticatedEventsEventIdRoute: typeof AuthenticatedEventsEventIdRoute
  AuthenticatedRunsRunIdRoute: typeof AuthenticatedRunsRunIdRoute
  AuthenticatedEventsIndexRoute: typeof AuthenticatedEventsIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedInboxesRoute: AuthenticatedInboxesRoute,
  AuthenticatedPricingRoute: AuthenticatedPricingRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedSetupRoute: AuthenticatedSetupRoute,
  AuthenticatedEventsEventIdRoute: AuthenticatedEventsEventIdRoute,
  AuthenticatedRunsRunIdRoute: AuthenticatedRunsRunIdRoute,
  AuthenticatedEventsIndexRoute: AuthenticatedEventsIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  CallbackRoute: CallbackRoute,
  LoginRoute: LoginRoute,
  OnboardingRoute: OnboardingRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
